import { render, staticRenderFns } from "./ProjectRubrics.vue?vue&type=template&id=3ff87473&scoped=true&"
import script from "./ProjectRubrics.vue?vue&type=script&lang=ts&"
export * from "./ProjectRubrics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff87473",
  null
  
)

export default component.exports